import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './component/userModule/login/login.component';
import { AuthGuard } from './services/auth-guard.service';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { HomepageComponent } from './frontend/homepage/homepage.component';
import { ServiceComponent } from './frontend/homepage/service/service.component';
import { LocationComponent } from './frontend/homepage/location/location.component';
import { ProsumerComponent } from './frontend/homepage/prosumer/prosumer.component';
import { EnterpriseComponent } from './frontend/homepage/enterprise/enterprise.component';
import { HandheldComponent } from './frontend/homepage/handheld/handheld.component';


const routes: Routes = [

  {
    path: '',
    component: HomepageComponent,


  },

  {
    path: 'service',
    component: ServiceComponent,


  },
  {
    path: 'login',
    component: LoginComponent,


  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard]


  },


  {
    path: 'location',
    component: LocationComponent,


  },



  // {
  //   path: 'catalog', children: [
  //     {
  //       path: 'prosumer', children: [
  //         {
  //           path: '',
  //           component: ProsumerComponent,

  //         },
  //       ]
  //     },
  //     {
  //       path: 'handheld', children: [
  //         {
  //           path: '',
  //           component: HandheldComponent,

  //         },
  //       ]
  //     },
  //     {
  //       path: 'enterprise', children: [
  //         {
  //           path: '',
  //           component: EnterpriseComponent,

  //         },
  //       ]
  //     },
  //   ]

  // },

  {
    path: "catalog",
    // data: {
    //   permissions: getPermissions(PAGE_PERMISSION.affiliate)
    // },
    children: [
      {
        path: "",
        component: ProsumerComponent,

      },

      {
        path: "view/:id",
        component: ProsumerComponent,

      },
    ],
  },

















  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
